// iconoir names per signal kind slug; unknown kinds fall back to the signals icon
const SIGNAL_ICONS: Record<string, string> = {
  'engagement.app_engagement_drop': 'GraphDown',
  'engagement.checkin_distress_unresolved': 'WarningTriangle',
  'engagement.checkin_drop': 'ChatBubbleCheck',
  'engagement.checkin_mood_shift': 'EmojiSad',
  'engagement.days_since_activity': 'CalendarXmark',
  'engagement.habit_completion_drop': 'TaskList',
  'engagement.never_activated': 'UserXmark',
  'engagement.no_first_action': 'LogIn',
  'intake.early_sentiment': 'Hourglass',
  'vocabulary.checkin_narrowing': 'TextSize',
  'vocabulary.checkin_novelty': 'Spark',
};

export const DEFAULT_SIGNAL_ICON = 'AntennaSignal';

export function signalIconName(kind: string): string {
  return SIGNAL_ICONS[kind] ?? DEFAULT_SIGNAL_ICON;
}
